import React, { useState, useEffect, useRef } from 'react';
import { Calendar, FileText, Download } from 'lucide-react';
import { EPaperCardProps } from '../types/epaper';
import './EPaperCard.css';

const EPaperCard: React.FC<EPaperCardProps> = ({ epaper, onClick, viewMode = 'grid' }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const loadedRef = useRef(false);

  useEffect(() => {
    setImageLoaded(false);
    setImageError(false);
    loadedRef.current = false;
    const timeout = setTimeout(() => {
      if (!loadedRef.current) setImageError(true);
    }, 5000);
    return () => clearTimeout(timeout);
  }, [epaper.thumbnailUrl]);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const isSpecialEdition = epaper.type === 'special';

  return (
    <div className={`epaper-card ${viewMode === 'list' ? 'epaper-card-list' : ''}`} onClick={onClick}>
      <div className="epaper-thumbnail">
        {!imageLoaded && !imageError && (
          <div className="thumbnail-placeholder">
            <div className="spinner"></div>
          </div>
        )}
        
        {!imageError && (
          <img 
            src={epaper.thumbnailUrl}
            alt={epaper.title}
            onLoad={() => { loadedRef.current = true; setImageLoaded(true); }}
            onError={() => setImageError(true)}
            style={{ display: imageLoaded ? 'block' : 'none' }}
            className="thumbnail-image"
          />
        )}
        
        {imageError && (
          <div className="thumbnail-fallback">
            <FileText size={48} />
            <span>{epaper.title}</span>
          </div>
        )}
        
        <div className="epaper-overlay">
          <Download size={20} />
        </div>
      </div>
      
      <div className="epaper-info">
        <h3 className="epaper-title">{epaper.title}</h3>
        {!isSpecialEdition && (
          <div className="epaper-meta">
            <Calendar size={16} />
            <span>{formatDate(epaper.date)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EPaperCard; 